import { Button, Cascader, Divider, Form, Modal, Space, message } from "antd";
import React, { useState } from "react";
import { apiCall } from "../../utils/Api";

export default function MoveComponent(props) {

    const { meta = { content: { location: "" } }, getGlobals = () => { }, getContent = () => { }, page_id = 0, component_id, menus = [] } = props;

    const [open, setOpen] = useState(false);
    const [id, setId] = useState(0);

    const convertMenus = (_arr) => {

        let m = [...menus]

        let _ret = m.filter(item => !item.parent_id).map(item => {
            return {
                value: item.id,
                label: item.name,
                children: m.filter(i => i.parent_id === item.id).map(child => {
                    return {
                        value: child.id,
                        label: child.name,
                    }
                })
            }
        })

        _ret.unshift({
            value: "global",
            label: "Global Banner",
            children: []
        })

        return _ret;

    }

    const options = convertMenus();


    const onChange = (_value) => {
        if (_value) {
            setId(_value[_value.length - 1]);
        }
    };

    const moveComponent = () => {

        let obj = {
            content_id: component_id,
        }

        if (page_id && meta.content.location !== "global") {
            obj.from_page_id = page_id
        }

        if (id && id !== "global") {
            obj.target_page_id = id;
        }

        apiCall("site_content/moveContent", obj, (_status, _result) => {
            if (_status) {
                message.success("Component moved successfully. ");
                getGlobals(true);

            } else {
                message.error(_result.error)
            }
            setOpen(false);
        });
    }

    const drawForm = () => {

        return (
            <>
                <strong>Move Component</strong>
                <Divider dashed style={{ "margin": "15px 0px" }} />
                <p>Move to the top of the selected page.</p>
                <Form>
                    <Cascader changeOnSelect style={{ "width": "100%" }} options={options} onChange={onChange} placeholder="Select page..." />
                    <br />
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <Space>
                            <Button onClick={() => setOpen(false)} type="default">Cancel</Button>
                            <Button disabled={(!id)} onClick={() => moveComponent()} type="primary">Move</Button>
                        </Space>
                    </div>
                </Form>
            </>
        )
    }

    return (
        <>
            <Modal destroyOnClose width={350} footer={null} onCancel={() => setOpen(false)} open={open}>
                {drawForm()}
            </Modal>
            <div onClick={() => setOpen(true)}>{props.children}</div>
        </>
    );

}